import Vue from 'vue'
import Router from 'vue-router'
// import {message} from '../../src/assets/js/zh-cn' //简体
import {message} from '../../src/assets/js/zh-hk' //繁体

Vue.use(Router)

const router = new Router({
  routes: [
    //登录
    {
      path: '/',
      name: 'login',
      component:  resolve => require(['@/page/login'], resolve),
      meta: {title: message.login}
    },
    //主界面
    {
      path: '/index',
      component:  resolve => require(['@/page/index'], resolve),
      children:[
        {
          path: '/',
          name: 'home',
          component: resolve => require(['@/page/home'], resolve),
          meta: {title: message.homepage}
        },
        //商品
        {
          path: '/productList',
          name: 'productList',
          component: resolve => require(['@/page/goods/product-list'], resolve),
          meta: {title: message.listCommodities}
        },
        {
          path: '/productListAdd',
          name: 'productListAdd',
          component: resolve => require(['@/page/goods/product-list-add'], resolve),
          meta: {title: message.addGoods}
        },
        {
          path: '/productListEdit/:sku_ids',
          name: 'productListEdit',
          component: resolve => require(['@/page/goods/product-list-edit'], resolve),
          meta: {title: message.editGoods}
        },
        {
          path: '/productListSee/:sku_ids',
          name: 'productListSee',
          component: resolve => require(['@/page/goods/product-list-see'], resolve),
          meta: {title: message.seeGoods}
        },
        {
          path: '/clothingList',
          name: 'clothingList',
          component: resolve => require(['@/page/goods/clothing-list'], resolve),
          meta: {title: message.listGarments}
        },
        {
          path: '/clothingListAdd',
          name: 'clothingListAdd',
          component: resolve => require(['@/page/goods/clothing-list-add'], resolve),
          meta: {title: message.seeClothing}
        },
        {
          path: '/clothingListEdit/:goods_id',
          name: 'clothingListEdit',
          component: resolve => require(['@/page/goods/clothing-list-edit'], resolve),
          meta: {title: message.editClothing}
        },
        {
          path: '/temporaryGoods',
          name: 'temporaryGoods',
          component: resolve => require(['@/page/goods/temporary-goods'], resolve),
          meta: {title: message.merchandiseTime}
        },
        {
          path: '/classifyManage',
          name: 'classifyManage',
          component: resolve => require(['@/page/goods/classify-manage'], resolve),
          meta: {title: message.classifiedManagement}
        },
        {
          path: '/brandManage',
          name: 'brandManage',
          component: resolve => require(['@/page/goods/brand-manage'], resolve),
          meta: {title: message.brandManagement}
        },
        {
          path: '/unitManage',
          name: 'unitManage',
          component: resolve => require(['@/page/goods/unit-manage'], resolve),
          meta: {title: message.unitManagement}
        },
        {
          path: '/specManage',
          name: 'specManage',
          component: resolve => require(['@/page/goods/spec-manage'], resolve),
          meta: {title: message.specificationManagement}
        },
        {
          path: '/colourManage',
          name: 'colourManage',
          component: resolve => require(['@/page/goods/colour-manage'], resolve),
          meta: {title: message.colorManagement}
        },
        {
          path: '/sizeManage',
          name: 'sizeManage',
          component: resolve => require(['@/page/goods/size-manage'], resolve),
          meta: {title: message.sizeManagement}
        },
        //订单
        {
          path: '/orderGoods',
          name: 'orderGoods',
          component: resolve => require(['@/page/order/order-goods'], resolve),
          meta: {title: message.orderForm}
        },
        {
          path: '/orderGoodsAdd',
          name: 'orderGoodsAdd',
          component: resolve => require(['@/page/order/order-goods-add'], resolve),
          meta: {title: message.addOrderGoods}
        },
        {
          path: '/orderGoodsEdit/:deal_id',
          name: 'orderGoodsEdit',
          component: resolve => require(['@/page/order/order-goods-edit'], resolve),
          meta: {title: message.editOrderGoods}
        },
        {
          path: '/orderGoodsSee/:deal_id',
          name: 'orderGoodsSee',
          component: resolve => require(['@/page/order/order-goods-see'], resolve),
          meta: {title: message.seeOrderGoods}
        },
        {
          path: '/returnBill',
          name: 'returnBill',
          component: resolve => require(['@/page/order/return-bill'], resolve),
          meta: {title: message.returnOrder}
        },
        {
          path: '/returnBillAdd',
          name: 'returnBillAdd',
          component: resolve => require(['@/page/order/return-bill-add'], resolve),
          meta: {title: message.addReturnBill}
        },
        {
          path: '/returnBillSee/:order_id',
          name: 'returnBillSee',
          component: resolve => require(['@/page/order/return-bill-see'], resolve),
          meta: {title: message.seeReturnBill}
        },
        {
          path: '/swapOrder',
          name: 'swapOrder',
          component: resolve => require(['@/page/order/swap-order'], resolve),
          meta: {title: message.swapOrder}
        },
        {
          path: '/swapOrderAdd',
          name: 'swapOrderAdd',
          component: resolve => require(['@/page/order/swap-order-add'], resolve),
          meta: {title: message.addswapOrder}
        },
        {
          path: '/swapOrderSee/:refundable_id',
          name: 'swapOrderSee',
          component: resolve => require(['@/page/order/swap-order-see'], resolve),
          meta: {title: message.seeswapOrder}
        },
        //库存
        {
          path: '/inventoryStatus',
          name: 'inventoryStatus',
          component:  resolve => require(['@/page/stock/inventory-status'], resolve),
          meta: {title: message.inventoryStatus}
        },
        {
          path: '/inventoryStatusDetailed/:sku_id',
          name: 'inventoryStatusDetailed',
          component:  resolve => require(['@/page/stock/inventory-status-detailed'], resolve),
          meta: {title: message.inventoryDetails}
        },
        {
          path: '/inventoryStatusStore/:sku_id',
          name: 'inventoryStatusStore',
          component:  resolve => require(['@/page/stock/inventory-status-store'], resolve),
          meta: {title: message.storeInventory}
        },
        {
          path: '/warehousingManage',
          name: 'warehousingManage',
          component:  resolve => require(['@/page/stock/warehousing-manage'], resolve),
          meta: {title: message.stockStock}
        },
        {
          path: '/warehousingManageAdd',
          name: 'warehousingManageAdd',
          component:  resolve => require(['@/page/stock/warehousing-manage-add'], resolve),
          meta: {title: message.addWarehousing}
        },
        {
          path: '/warehousingManageEdit/:rkd_id',
          name: 'warehousingManageEdit',
          component:  resolve => require(['@/page/stock/warehousing-manage-edit'], resolve),
          meta: {title: message.editWarehousing}
        },
        {
          path: '/warehousingManageSee/:rkd_id',
          name: 'warehousingManageSee',
          component:  resolve => require(['@/page/stock/warehousing-manage-see'], resolve),
          meta: {title: message.seeWarehousing}
        },
        {
          path: '/outgoingManage',
          name: 'outgoingManage',
          component:  resolve => require(['@/page/stock/outgoing-manage'], resolve),
          meta: {title: message.stockOutStock}
        },
        {
          path: '/outgoingManageAdd',
          name: 'outgoingManageAdd',
          component:  resolve => require(['@/page/stock/outgoing-manage-add'], resolve),
          meta: {title: message.addOutgoing}
        },
        {
          path: '/outgoingManageEdit/:ckd_id',
          name: 'outgoingManageEdit',
          component:  resolve => require(['@/page/stock/outgoing-manage-edit'], resolve),
          meta: {title: message.editOutgoing}
        },
        {
          path: '/outgoingManageSee/:ckd_id',
          name: 'outgoingManageSee',
          component:  resolve => require(['@/page/stock/outgoing-manage-see'], resolve),
          meta: {title: message.seeOutgoing}
        },
        {
          path: '/allocationManage',
          name: 'allocationManage',
          component:  resolve => require(['@/page/stock/allocation-manage'], resolve),
          meta: {title: message.inventoryAllocation}
        },
        {
          path: '/allocationManageAdd',
          name: 'allocationManageAdd',
          component:  resolve => require(['@/page/stock/allocation-manage-add'], resolve),
          meta: {title: message.addAllocation}
        },
        {
          path: '/allocationManageEdit/:dhd_id',
          name: 'allocationManageEdit',
          component:  resolve => require(['@/page/stock/allocation-manage-edit'], resolve),
          meta: {title: message.editAllocation}
        },
        {
          path: '/allocationManageSee/:dhd_id',
          name: 'allocationManageSee',
          component:  resolve => require(['@/page/stock/allocation-manage-see'], resolve),
          meta: {title: message.seeAllocation}
        },
        {
          path: '/checkManage',
          name: 'checkManage',
          component:  resolve => require(['@/page/stock/check-manage'], resolve),
          meta: {title: message.stockTaking}
        },
        {
          path: '/checkManageAdd',
          name: 'checkManageAdd',
          component:  resolve => require(['@/page/stock/check-manage-add'], resolve),
          meta: {title: message.addCheck}
        },
        {
          path: '/checkManageEdit/:pdd_id',
          name: 'checkManageEdit',
          component:  resolve => require(['@/page/stock/check-manage-edit'], resolve),
          meta: {title: message.editCheck}
        },
        {
          path: '/checkManageSee/:pdd_id',
          name: 'checkManageSee',
          component:  resolve => require(['@/page/stock/check-manage-see'], resolve),
          meta: {title: message.seeCheck}
        },
        //采购
        {
          path: '/purchaseManage',
          name: 'purchaseManage',
          component:  resolve => require(['@/page/purchase/purchase-manage'], resolve),
          meta: {title: message.purchaseOrder}
        },
        {
          path: '/purchaseManageAdd',
          name: 'purchaseManageAdd',
          component:  resolve => require(['@/page/purchase/purchase-manage-add'], resolve),
          meta: {title: message.addPurchase}
        },
        {
          path: '/purchaseManageEdit/:cgd_id',
          name: 'purchaseManageEdit',
          component:  resolve => require(['@/page/purchase/purchase-manage-edit'], resolve),
          meta: {title: message.editPurchase}
        },
        {
          path: '/purchaseManageSee/:cgd_id',
          name: 'purchaseManageSee',
          component:  resolve => require(['@/page/purchase/purchase-manage-see'], resolve),
          meta: {title: message.seePurchase}
        },
        {
          path: '/purchaseManageStorage/:cgd_id',
          name: 'purchaseManageStorage',
          component:  resolve => require(['@/page/purchase/purchase-manage-storage'], resolve),
          meta: {title: message.storagePurchase}
        },
        {
          path: '/procurementPlan',
          name: 'procurementPlan',
          component:  resolve => require(['@/page/purchase/procurement-plan'], resolve),
          meta: {title: message.purchasePlan}
        },
        {
          path: '/supplierManagement',
          name: 'supplierManagement',
          component:  resolve => require(['@/page/purchase/supplier-management'], resolve),
          meta: {title: message.supplierManagement}
        },
        //客户
        {
          path: '/customerList',
          name: 'customerList',
          component:  resolve => require(['@/page/customer/customer-list'], resolve),
          meta: {title: message.customerList}
        },
        {
          path: '/consumptionRecord/:cust_id',
          name: 'consumptionRecord',
          component:  resolve => require(['@/page/customer/consumption-record'], resolve),
          meta: {title: message.recordsConsumption}
        },
        {
          path: '/auditList',
          name: 'auditList',
          component:  resolve => require(['@/page/customer/audit-list'], resolve),
          meta: {title: message.pendingCustomers}
        },
        {
          path: '/priceGrouping',
          name: 'priceGrouping',
          component:  resolve => require(['@/page/customer/price-grouping'], resolve),
          meta: {title: message.priceGrouping}
        },
        {
          path: '/customerType',
          name: 'customerType',
          component:  resolve => require(['@/page/customer/customer-type'], resolve),
          meta: {title: message.customerTypeSettings}
        },
        {
          path: '/regionalGrouping',
          name: 'regionalGrouping',
          component:  resolve => require(['@/page/customer/regional-grouping'], resolve),
          meta: {title: message.regionalGroupingSettings}
        },
        //收银
        {
          path: '/goodsCashier',
          name: 'goodsCashier',
          component:  resolve => require(['@/page/retail/goods-cashier'], resolve),
          meta: {title: message.cashier}
        },
        {
          path: '/salesManagement',
          name: '',
          component:  resolve => require(['@/page/retail/sales-management'], resolve),
          children:[
            {
              path: '/',
              name: 'salesRecord',
              component:  resolve => require(['@/page/retail/sales-record'], resolve),
              meta: {title: message.salesRecords}
            },
            {
              path: '/returnRecord',
              name: 'returnRecord',
              component:  resolve => require(['@/page/retail/return-record'], resolve),
              meta: {title: message.returnRecords}
            },
          ]
        },
        {
          path: '/salesRecordSee/:deal_Id',
          name: 'salesRecordSee',
          component:  resolve => require(['@/page/retail/sales-record-see'], resolve),
          meta: {title: message.seeSalesRecord}
        },
        {
          path: '/returnRecordSee/:order_Id',
          name: 'returnRecordSee',
          component:  resolve => require(['@/page/retail/return-record-see'], resolve),
          meta: {title: message.seeReturnRecord}
        },
        {
          path: '/diurnalRecord',
          name: 'diurnalRecord',
          component:  resolve => require(['@/page/retail/diurnal-record'], resolve),
          meta: {title: message.dailyRecord}
        },
        {
          path: '/cashierSet',
          name: '',
          component:  resolve => require(['@/page/retail/cashier-set'], resolve),
          children:[
            {
              path: '/',
              name: 'cashierSetting',
              component:  resolve => require(['@/page/retail/cashier-setting'], resolve),
              meta: {title: message.cashRegisterSettings}
            },
            {
              path: '/paymentSetting',
              name: 'paymentSetting',
              component:  resolve => require(['@/page/retail/payment-setting'], resolve),
              meta: {title: message.paymentSettings}
            },
          ]
        },
        //销售
        {
          path: '/salesSlip',
          name: 'salesSlip',
          component:  resolve => require(['@/page/market/sales-slip'], resolve),
          meta: {title: message.salesSlip}
        },
        {
          path: '/salesSlipAdd',
          name: 'salesSlipAdd',
          component:  resolve => require(['@/page/market/sales-slip-add'], resolve),
          meta: {title: message.addSalesSlip}
        },
        {
          path: '/salesSlipSee/:dealId',
          name: 'salesSlipSee',
          component:  resolve => require(['@/page/market/sales-slip-see'], resolve),
          meta: {title: message.editSalesSlip}
        },
        //外勤
        {
          path: '/salesmanList',
          name: 'salesmanList',
          component:  resolve => require(['@/page/salesman/salesman-list'], resolve),
          meta: {title: message.salesmanList}
        },
        {
          path: '/taskManage',
          name: 'taskManage',
          component:  resolve => require(['@/page/salesman/task-manage'], resolve),
          meta: {title: message.taskManagement}
        },
        {
          path: '/taskManageAdd',
          name: 'taskManageAdd',
          component:  resolve => require(['@/page/salesman/task-manage-add'], resolve),
          meta: {title: message.addTask}
        },
        {
          path: '/taskManageEdit/:task_id',
          name: 'taskManageEdit',
          component:  resolve => require(['@/page/salesman/task-manage-edit'], resolve),
          meta: {title: message.editTask}
        },
        {
          path: '/taskManageSee/:task_id',
          name: 'taskManageSee',
          component:  resolve => require(['@/page/salesman/task-manage-see'], resolve),
          meta: {title: message.seeTask}
        },
        {
          path: '/signManage',
          name: '',
          component:  resolve => require(['@/page/salesman/sign-manage'], resolve),
          children:[
            {
              path: '/',
              name: 'signTask',
              component:  resolve => require(['@/page/salesman/sign-task'], resolve),
              meta: {title: message.signTask}
            },
            {
              path: '/signSituation',
              name: 'signSituation',
              component:  resolve => require(['@/page/salesman/sign-situation'], resolve),
              meta: {title: message.signSituation}
            },
            {
              path: '/monthlySummary',
              name: 'monthlySummary',
              component:  resolve => require(['@/page/salesman/monthly-summary'], resolve),
              meta: {title: message.monthlySummary}
            },
          ]
        },
        {
          path: '/signTaskAdd',
          name: 'signTaskAdd',
          component:  resolve => require(['@/page/salesman/sign-task-add'], resolve),
          meta: {title: message.addSignTask}
        },
        {
          path: '/signTaskEdit/:task_Id',
          name: 'signTaskEdit',
          component:  resolve => require(['@/page/salesman/sign-task-edit'], resolve),
          meta: {title: message.editSignTask}
        },
        {
          path: '/signTaskSee/:task_Id',
          name: 'signTaskSee',
          component:  resolve => require(['@/page/salesman/sign-task-see'], resolve),
          meta: {title: message.seeSignTask}
        },
        {
          path: '/reportTask',
          name: '',
          component:  resolve => require(['@/page/salesman/report-task'], resolve),
          children:[
            {
              path: '/',
              name: 'displayInspection',
              component:  resolve => require(['@/page/salesman/display-inspection'], resolve),
              meta: {title: message.displayInspection}
            },
            {
              path: '/photoRecord',
              name: 'photoRecord',
              component:  resolve => require(['@/page/salesman/photo-record'], resolve),
              meta: {title: message.photoRecord}
            },
            {
              path: '/stockReport',
              name: 'stockReport',
              component:  resolve => require(['@/page/salesman/stock-report'], resolve),
              meta: {title: message.stockReport}
            },
          ]
        },
        //财务
        {
          path: '/accountType',
          name: 'accountType',
          component:  resolve => require(['@/page/finance/account-type'], resolve),
          meta: {title: message.accountType}
        },
        {
          path: '/capitalFlow',
          name: 'capitalFlow',
          component:  resolve => require(['@/page/finance/capital-flow'], resolve),
          meta: {title: message.capitalFlow}
        },
        //微店铺
        {
          path: '/bindingShop',
          name: 'bindingShop',
          component:  resolve => require(['@/page/mall/binding-shop'], resolve),
          meta: {title: message.bindingMicrostores}
        },
        {
          path: '/generalSet',
          name: 'generalSet',
          component:  resolve => require(['@/page/mall/general-set'], resolve),
          meta: {title: message.generalStoreSettings}
        },
        {
          path: '/goodsDisplay',
          name: 'goodsDisplay',
          component:  resolve => require(['@/page/mall/goods-display'], resolve),
          meta: {title: message.merchandiseDisplay}
        },
        {
          path: '/adPosition',
          name: 'adPosition',
          component:  resolve => require(['@/page/mall/ad-position'], resolve),
          meta: {title: message.advertisingSpace}
        },
        {
          path: '/deliveryWay',
          name: 'deliveryWay',
          component:  resolve => require(['@/page/mall/delivery-way'], resolve),
          meta: {title: message.fistributionMode}
        },
        {
          path: '/paymentMethod',
          name: 'paymentMethod',
          component:  resolve => require(['@/page/mall/payment-method'], resolve),
          meta: {title: message.paymentMethod}
        },
        {
          path: '/myBalance',
          name: 'myBalance',
          component:  resolve => require(['@/page/mall/my-balance'], resolve),
          meta: {title: message.myBalance}
        },
        //报表
        {
          path: '/customerStatistics',
          name: 'customerStatistics',
          component:  resolve => require(['@/page/report/customer-statistics'], resolve),
          meta: {title: message.salesReport}
        },
        {
          path: '/goodsStatistics',
          name: '',
          component:  resolve => require(['@/page/report/goods-statistics'], resolve),
          children:[
            {
              path: '/',
              name: 'salesStatistics',
              component:  resolve => require(['@/page/report/sales-statistics'], resolve),
              meta: {title: message.commodityStatement}
            },
            {
              path: '/classifyStatistics',
              name: 'classifyStatistics',
              component:  resolve => require(['@/page/report/classify-statistics'], resolve),
              meta: {title: message.classifiedReport}
            },
            {
              path: '/brandStatistics',
              name: 'brandStatistics',
              component:  resolve => require(['@/page/report/brand-statistics'], resolve),
              meta: {title: message.brandReport}
            },
          ]
        },
        {
          path: '/orderStatistics',
          name: 'orderStatistics',
          component:  resolve => require(['@/page/report/order-statistics'], resolve),
          meta: {title: message.orderReport}
        },
        {
          path: '/performanceStatistics',
          name: 'performanceStatistics',
          component:  resolve => require(['@/page/report/performance-statistics'], resolve),
          meta: {title: message.performanceReport}
        },
        {
          path: '/performanceStatisticsSee/:emp_no',
          name: 'performanceStatisticsSee',
          component:  resolve => require(['@/page/report/performance-statistics-see'], resolve),
          meta: {title: message.seeAchievement}
        },
        //智能
        {
          path: '/orderAutomation',
          name: 'orderAutomation',
          component:  resolve => require(['@/page/intelligence/order-automation'], resolve),
          meta: {title: message.orderAutomation}
        },
        //设置
        {
          path: '/storeManage',
          name: 'storeManage',
          component:  resolve => require(['@/page/set/store-manage'], resolve),
          meta: {title: message.storeManagement}
        },
        {
          path: '/employeeManagement',
          name: '',
          component:  resolve => require(['@/page/set/employee-management'], resolve),
          children:[
            {
              path: '/',
              name: 'employeeList',
              component:  resolve => require(['@/page/set/employee-list'], resolve),
              meta: {title: message.employeeAccountNumber}
            },
            {
              path: '/countermanList',
              name: ' countermanList',
              component:  resolve => require(['@/page/set/counterman-list'], resolve),
              meta: {title: message.salesmanAccount}
            },
          ]
        },
        {
          path: '/employeeListAdd',
          name: 'employeeListAdd',
          component:  resolve => require(['@/page/set/employee-list-add'], resolve),
          meta: {title: message.addEmployee}
        },
        {
          path: '/employeeListEdit/:empNO',
          name: 'employeeListEdit',
          component:  resolve => require(['@/page/set/employee-list-edit'], resolve),
          meta: {title: message.editEmployee}
        },
        {
          path: '/rolePermissions',
          name: 'rolePermissions',
          component:  resolve => require(['@/page/set/role-permissions'], resolve),
          meta: {title: message.privilegeManagement}
        },
        {
          path: '/attendanceManagement',
          name: '',
          component:  resolve => require(['@/page/set/attendance-management'], resolve),
          children:[
            {
              path: '/',
              name: 'attendanceSet',
              component:  resolve => require(['@/page/set/attendance-set'], resolve),
              meta: {title: message.attendanceSettings}
            },
            {
              path: '/attendanceCollect',
              name: 'attendanceCollect',
              component:  resolve => require(['@/page/set/attendance-collect'], resolve),
              meta: {title: message.attendanceSummary}
            },
          ]
        },
        {
          path: '/printManagement',
          name: '',
          component:  resolve => require(['@/page/set/print-management'], resolve),
          children:[
            {
              path: '/',
              name: 'printSet',
              component:  resolve => require(['@/page/set/print-set'], resolve),
              meta: {title: message.orderTemplate}
            },
            {
              path: '/printRuSet',
              name: 'printRuSet',
              component:  resolve => require(['@/page/set/printRu-set'], resolve),
              meta: {title: message.warehousingTemplate}
            },
            {
              path: '/printChuSet',
              name: 'printChuSet',
              component:  resolve => require(['@/page/set/printChu-set'], resolve),
              meta: {title: message.exitTemplate}
            },
            {
              path: '/printTiaoSet',
              name: 'printTiaoSet',
              component:  resolve => require(['@/page/set/printTiao-set'], resolve),
              meta: {title: message.callTemplate}
            },
            {
              path: '/printCaiSet',
              name: 'printCaiSet',
              component:  resolve => require(['@/page/set/printCai-set'], resolve),
              meta: {title: message.purchasingTemplate}
            },
            {
              path: '/cashierPrint',
              name: 'cashierPrint',
              component:  resolve => require(['@/page/set/cashier-print'], resolve),
              meta: {title: message.cashTemplate}
            },
          ]
        },
        {
          path: '/companyInfo',
          name: 'companyInfo',
          component:  resolve => require(['@/page/set/company-info'], resolve),
          meta: {title: message.companyInformation}
        },
        {
          path: '/systemSet',
          name: 'systemSet',
          component:  resolve => require(['@/page/set/system-set'], resolve),
          meta: {title: message.systemSetup}
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title + ' - ' + message.systemName
  }
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js